import React from "react";

function ReportMemberShipDetails(props) {
    const { title, data } = props

    return  (<div className="total_report_detail_day container" style={{maxWidth:'200px'}}>
              <div style={{fontSize:'1.2rem', padding: '12px 4px', margin : 'auto', border:'1px solid' }}>
                <h4>{title.row1}</h4>
                <h4>{title.row2}</h4>
                {data.number !== "" && <div style={{fontSize:'1.5rem', color:'purple', fontWeight:'600'}}>{Number(data.number).toLocaleString()}</div>}
              </div>
      </div>)
}

export default ReportMemberShipDetails;